import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router-dom";
import useTendering from "../../../hooks/useTendering";
import { toast } from "react-toastify";
import AppContext from "../../../AppContext";

const Participate = (props) => {
  const { id } = useParams();
  const { isAuth, user } = useContext(AppContext);
  const { getById } = useTendering();
  const [detail, setDetail] = useState(undefined);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuth) {
      navigate(`/tenderings/${id}`);
      return;
    }

    getById(id)
      .then((response) => {
        if (user._id === response.createdBy) {
          navigate(`/tenderings/${id}`);
          return;
        }

        setDetail(response);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [id]);

  useEffect(() => {}, [detail]);

  return <div>Participate</div>;
};

Participate.propTypes = {};

export default Participate;
